import React, { useEffect, useState } from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Hero from "../components/Hero";
import Section from "../components/Section";
import Download from "../components/Download";
import { useSelector } from "react-redux";
import CoreValues from "components/CoreValues";
import Availability from "components/Availability";
import useStyles from "styles/styles";
import HomeFooter from "components/Footer/HomeFooter";
import FastRidesSection from "components/FastRidesSection";

const dashboardRoutes = [];

export default function LandingPage(props) {
  const classes = useStyles();
  const auth = useSelector((state) => state.auth);

  const { ...rest } = props;

  const [role, setRole] = useState();

  useEffect(() => {
    if (auth && auth.profile) {
      if (auth.profile.uid) {
        let role = auth.profile.usertype;
        setRole(role);
      }
    }
  }, [auth]);

  return (
    <div style={{ zIndex: "500" }}>
      <div className={classes.landingContainer}>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "dark",
          }}
          {...rest}
        />

        <Hero role={role} />
        <Section />
        <FastRidesSection />
        <Download />
      </div>
      <CoreValues />
      <Availability />
      <HomeFooter />
    </div>
  );
}
